<template>
  <div v-if="value?.length" class="space-y-5">
    <div v-for="statusInfo in value" :key="statusInfo.id ?? statusInfo.status">
      <loader
        v-if="loadingStatusId === statusInfo.id"
        :is-loading="isLoading"
      />
      <task-status-dropdown
        :task-status="statusInfo.status"
        class="cursor-pointer"
        data-cy="task-status-dropdown"
        @change="updateTask($event, statusInfo)"
      />
    </div>
  </div>

  <span v-else>-</span>
</template>
<script setup lang="ts">
import { ref } from "vue";

import { usePromiseWrapper } from "@/hooks/common";
import communicationService from "@/services/modules/communication";

import TaskStatusDropdown from "@/components/communicationLogs/forms/TaskStatusDropdown.vue";
import Loader from "@/components/ui/Loader.vue";

import type { TaskStatuses } from "@/enums/communicationLogs";

const { value } = defineProps<{
  value?: { status: TaskStatuses; id: number | null }[];
}>();

const loadingStatusId = ref<number | null>(null);

const { fetchWrapper: updateTask, loading: isLoading } = usePromiseWrapper(
  async (
    newStatus: TaskStatuses,
    statusInfo: { id: number | null; status: TaskStatuses }
  ) => {
    if (statusInfo.status === newStatus || !statusInfo.id) {
      return;
    }

    loadingStatusId.value = statusInfo.id;

    await communicationService.updateTask(statusInfo.id, {
      status: newStatus,
    });
  }
);
</script>
